import React, { useEffect, useState } from 'react';

import { Box, useTheme } from '@mui/material';
import { motion, useScroll } from 'framer-motion';


const Divider = ({ height, minus }) => {
    const theme = useTheme();
    const { scrollYProgress } = useScroll();

    const [isScrollSection, setIsScrollSection] = useState(false);
    const [dividerWidth, setDividerWidth] = useState(0); // Initial width (in %)


    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleScroll = () => {
                const position = window.scrollY;

                // console.log(position);
                if (position >= height) {
                    setIsScrollSection(true);
                    // Map scroll percentage to a width range (10% to 100%)
                    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
                    const scrollPercent = ((position - minus) / documentHeight) * 2000;
                    const newWidth = Math.min(100, Math.max(10, scrollPercent + 10)); // Adjust range as needed
                    setDividerWidth(newWidth);
                } else {
                    setIsScrollSection(false);
                    setDividerWidth(0);


                }
            };

            window.addEventListener('scroll', handleScroll);

            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, [isScrollSection]);


    return (
        <>
            <Box style={{ backgroundColor: '#fff' }}>
                <Box
                    sx={{
                        display: 'flex',
                        // marginTop: '150px',
                        // marginBottom: '150px',
                        justifyContent: 'center',
                        padding: '100px 30px',
                        width: '100%',
                        [theme.breakpoints.down('md')]: {
                            padding: '50px 30px',
                        },
                    }}
                >
                    <motion.div
                        style={{
                            height: '8px', // Divider thickness
                            background: 'linear-gradient(90deg, #00FF00 0%, #01B762 50.44%, #017780 100%)',
                            marginTop: '20px',
                            borderRadius: '100px',
                        }}
                        animate={{ width: `${dividerWidth}%` }} // Animate width change
                        transition={{ duration: 0.5, ease: 'easeOut' }} // Smooth transition
                    />
                </Box>
            </Box>
        </>
    );
};

export default Divider;
